var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssignAssessmentEmptyState1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 131,
    viewBox: "0 0 131 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9060_291853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.0599 37.9837C42.9835 35.8278 44.6304 33.9996 46.7826 33.8514L87.8464 31.0243C90.1582 30.8651 92.1211 32.6975 92.1211 35.0148V98.3352C92.1211 100.544 90.3302 102.335 88.1211 102.335H49.2013C47.0473 102.335 45.2801 100.63 45.2038 98.4769L43.0599 37.9837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1484 100.371V100.371C45.9392 100.539 44.8462 99.6341 44.7854 98.4148L41.7224 36.9272C41.6125 34.7213 43.3111 32.8439 45.5169 32.7332L87.408 30.6307C89.588 30.5213 91.4532 32.1798 91.5995 34.3576L91.8984 38.8086",
    stroke: "#333333",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.1254,
    y: 42.3681,
    width: 49.78,
    height: 67.3087,
    rx: 3.4,
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.413 71.9788H60.6731C60.4163 71.9788 60.209 71.7725 60.209 71.517C60.209 71.2614 60.4163 71.0552 60.6731 71.0552H78.413C78.6698 71.0552 78.8771 71.2614 78.8771 71.517C78.8771 71.7725 78.6698 71.9788 78.413 71.9788Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.413 94.9514H60.6731C60.4163 94.9514 60.209 94.7452 60.209 94.4896C60.209 94.2341 60.4163 94.0278 60.6731 94.0278H78.413C78.6698 94.0278 78.8771 94.2341 78.8771 94.4896C78.8771 94.7452 78.6698 94.9514 78.413 94.9514Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.413 84.0344H60.6731C60.4163 84.0344 60.209 83.8282 60.209 83.5726C60.209 83.3171 60.4163 83.1108 60.6731 83.1108H78.413C78.6698 83.1108 78.8771 83.3171 78.8771 83.5726C78.8771 83.8282 78.6698 84.0344 78.413 84.0344Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2539 50.8452H93.0819C93.9103 50.8452 94.5819 51.5168 94.5819 52.3452V57.9228C94.5819 58.7512 93.9103 59.4228 93.0819 59.4228H60.2539C59.4255 59.4228 58.7539 58.7512 58.7539 57.9228V52.3452C58.7539 51.5168 59.4255 50.8452 60.2539 50.8452Z",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.457 64.4229H93.0819C93.9103 64.4229 94.5819 65.0944 94.5819 65.9229V71.5005C94.5819 72.3289 93.9103 73.0005 93.0819 73.0005H87.457C86.6286 73.0005 85.957 72.3289 85.957 71.5005V65.9229C85.957 65.0944 86.6286 64.4229 87.457 64.4229Z",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.457 78.0005H93.0819C93.9103 78.0005 94.5819 78.6721 94.5819 79.5005V85.0781C94.5819 85.9065 93.9103 86.5781 93.0819 86.5781H87.457C86.6286 86.5781 85.957 85.9065 85.957 85.0781V79.5005C85.957 78.6721 86.6286 78.0005 87.457 78.0005Z",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.457 91.5781H93.0819C93.9103 91.5781 94.5819 92.2497 94.5819 93.0781V98.6557C94.5819 99.4842 93.9103 100.156 93.0819 100.156H87.457C86.6286 100.156 85.957 99.4842 85.957 98.6557V93.0781C85.957 92.2497 86.6286 91.5781 87.457 91.5781Z",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7734 87.0586L29.8399 31.524C29.5272 29.3349 31.0501 27.3074 33.2396 26.9977L74.7932 21.1215C76.9882 20.811 79.017 22.345 79.3166 24.5416L79.5234 26.0586",
    stroke: "#333333",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2954 40.8374C46.2136 38.6715 47.8718 36.8345 50.0347 36.6947L94.3242 33.8337C96.63 33.6847 98.582 35.5147 98.582 37.8253V101.164C98.582 103.373 96.7912 105.164 94.582 105.164H73.6536H52.5769C50.4265 105.164 48.6609 103.464 48.5797 101.315L46.2954 40.8374Z",
    fill: "#763FE3",
    fillOpacity: 0.12
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9060_291853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72.7141,
    height: 89.9359,
    fill: "white",
    transform: "translate(28.791 20.3408)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignAssessmentEmptyState1);
export default __webpack_public_path__ + "static/media/assign-assessment-empty-state-1.4230daa5e19274f56300c1578692e91a.svg";
export { ForwardRef as ReactComponent };